import React from 'react';
import { Button } from 'react-bootstrap';

export default function ButtonRed(props) {
    return (
        <div className="d-flex justify-content-center justify-content-lg-start">
            <Button target="_blank" href={props.href} type="button" className="btn btn-danger text-white fw-bold px-5 py-2">
                <p className="button-title mb-0">{props.title}</p>
            </Button>
        </div>
    );
}
